import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop/>
      <GoogleOAuthProvider
        clientId="927284334937-r7h9rpjfutpam4c0mjhto46otqjauahe.apps.googleusercontent.com">
        <App/>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
